import * as React from 'react';
import { Box } from '../../Box';
import { Text } from '../../Text';
export var ChangesCountLabel = function ChangesCountLabel(_ref) {
  var count = _ref.count;
  var changes = count === 1 ? 'change' : 'changes';
  return React.createElement(Box, {
    lss: {
      display: 'inline',
      mr: 'xxl'
    }
  }, React.createElement(Text, {
    as: "strong",
    lss: {
      mr: 'sm'
    }
  }, count), React.createElement(Text, {
    lss: {
      textScale: 'caption',
      fontWeight: 'medium',
      textStyle: 'caps'
    }
  }, changes, " made"));
};